import { render } from "./Conference.vue?vue&type=template&id=1af99806"
import script from "./Conference.vue?vue&type=script&lang=js"
export * from "./Conference.vue?vue&type=script&lang=js"

import "./Conference.vue?vue&type=style&index=0&id=1af99806&lang=css"
script.render = render

export default script